import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { AppServiceManager } from './appServiceManager';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(private appServiceManager: AppServiceManager) { }

  private _subject = new Subject<any>();
  // private _deActivateMemberSubject = new Subject<any>();
  private eventSubject = new BehaviorSubject<any>(undefined);
  private data: | undefined;

  defaulterNotificationRefresh(event) {
    this._subject.next(event);
  }

  deActivateMember(event) {
    this.eventSubject.next(event);
  }

  get events$() {
    return this._subject.asObservable();
  }

  // get eventsactivateMember$ () {
  //   return this._deActivateMemberSubject.asObservable();
  // }

  getEventSubject(): BehaviorSubject<any> {
    return this.eventSubject;
  }

  getCustomerByID(memberID: string): Observable<any[]> {
    return this.appServiceManager.get("customers/" + memberID);
  }
  
}
